import Vue from "vue";
import Router from "vue-router";

// 懒加载方式，当路由被访问的时候才加载对应组件
const Login = resolve => require(["@/components/Login"], resolve);

const Home = resolve => require(["@/components/Home"], resolve);
const information = resolve =>
  require(["@/components/information/information.vue"], resolve);
  const index = resolve =>
  require(["@/components/information/index.vue"], resolve);
Vue.use(Router);
let router = new Router({
  // mode: 'history',
  routes: [
    {
      path: "/",
      redirect: "/index"
    },
    {
      path: "/login",
      name: "登录",
      component: Login
    },
    {
      path: "/",
      component: Home,
      leaf: true, // 只有一个节点
      menuShow: true,
      children: [
        {
          path: "/index",
          component: index,
          name: "首页",
          menuShow: true
        },
        {
          path: "/information",
          component: information,
          name: "完善信息页",
          menuShow: true
        }
      ]
    }
  ]
});

router.beforeEach((to, from, next) => {
  // console.log('to:' + to.path)
  //startsWith返回一个布尔值，表示参数字符串是否在原字符串头部NewSite
  // let arrs = localStorage.getItem('access-authType');
  // if (arrs){
  //   for(let j = 0 ;j < router.options.routes.length; j++){
  //     for(let k = 0;k < arrs.length; k++){
  //       if(router.options.routes[j].idthat && router.options.routes[j].idthat == arrs[k]){
  //         router.options.routes[j].menuShow = true
  //       }
  //     }
  //   }
  // }

  if (to.path.startsWith("/login")) {
    window.localStorage.removeItem("userInfo");
    window.localStorage.removeItem("username");
    localStorage.removeItem("registeredData");
    next();
  } else {
    let userInfo = JSON.parse(window.localStorage.getItem("userInfo"));
    if (userInfo && userInfo.companyId) {
      next();
    } else {
      next({ path: "/login" });
    }
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js